export default "__VITE_ASSET__DMXSxQP3__"